import React from 'react';

import type { VendorImageProps } from './types';

import classes from './VendorImages.module.css';

export function VendorImage({ image }: VendorImageProps) {
  if (!image) {
    return null;
  }

  return (
    <div
      className={classes['single-image-container']}
      style={{
        backgroundImage: `url(${image})`,
      }}
    />
  );
}
